import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import type { OneGraphServiceV1 } from '@oneaudi/onegraph-service';
import type { Logger } from '@feature-hub/logger';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { LayerManagerV25 } from '@volkswagen-onehub/layer-manager';

export type NodeEnvironment = 'development' | 'production';

export enum ThemeColor {
  Dark = 'dark',
  Light = 'light',
}
export type HeadingTag = 'h2' | 'h3' | 'h4';

export type TrackingClickEvent = {
  pos?: number;
  elementName?: 'image' | 'button' | 'link';
  value?: string;
  label?: string;
};

export interface BasicTeaserServices {
  localeService: LocaleServiceV1;
  trackingService?: TrackingServiceV2;
  loggerService?: Logger;
  oneGraphService: OneGraphServiceV1;
  layerManager?: LayerManagerV25;
}

export interface BasicTeaserCtaButton {
  label: string;
  url: string;
  variant?: 'primary' | 'secondary';
  ariaLabel?: string;
  openInTabOrLayer: 'page' | 'tab' | 'layer' | 'chatbot';
  chatBotId?: string;
  needsConfirmation?: boolean;
}

export type AssetType = AssetTypeImage | AssetTypeVideo;

export interface AssetTypeImage {
  assetType: 'image';
  src: {
    assetValue: string;
  };
  alt?: string;
  assetDisclaimers?: string[];
  mediaPosition?: 'left' | 'right';
  aspectRatio?: '16:9' | '1:1';
}

export interface AssetTypeVideo {
  assetType: 'video';
  src: {
    assetValue: string;
  };
  alt?: string;
  assetDisclaimers?: string[];
  poster?: {
    assetValue: string;
  };
  captions?: {
    assetValue: string;
  };
  audioDescription?: {
    assetValue: string;
  };
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  preserveVideoWidth?: boolean;
  mediaPosition?: 'left' | 'right';
  aspectRatio?: '16:9' | '1:1';
}

export interface BasicTeaserContent {
  asset: AssetType;
  heading?: string;
  headingTag?: HeadingTag;
  subHeading?: string;
  text?: string;
  buttons?: BasicTeaserCtaButton[];
  themeColor?: ThemeColor;
  consumptionAndEmissions?: string[];
  disclaimers?: string[];
  supplier?: {
    supplierName: string;
    supplierLink: {
      label: string;
      url: string;
      ariaLabel: string;
    };
  };
}
export interface FeatureAppMeta {
  id: string;
}
